import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { NbAuthService } from "@nebular/auth";
import { Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> | Promise<boolean> | boolean => {
  const authService = inject(NbAuthService);
  const router = inject(Router);

  return authService.isAuthenticated().pipe(
    tap((authenticated) => {
      if (!authenticated) {
        router.navigate(["auth"]);
      }
    }),
    map((authenticated) => (authenticated ? true : false))
  );
};
